import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { Category } from './Category';

const mapStateToProps = (state, ownProps) => ({
  property: entitySelectors.getProperty(state),
  category: entitySelectors.getCategory(state, ownProps.id),
});

export const CategoryContainer = connect(mapStateToProps)(Category);
